import TermList from "../AdminTermList";

export default class AdminTermListNoteType extends TermList {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return "note_type";
    }
}
